<template>
  <div class="container">
    <div v-if="isDialogVisible" class="dialog">
      <div class="overlay"></div>
      <div class="content">
        <img class="icon" src="../../assets/shop/tip_icon.png" alt="">
        <h2 style="
            margin-bottom: 1.2rem;
            color: rgba(0, 0, 0, 1);
            font-size: 1rem;
          ">
          温馨提示
        </h2>
        <p style="
            font-size: 0.7rem;
            color: rgba(0, 0, 0, 1);
            width: 12.75rem;
            margin-bottom: 2.15rem;
          ">
          您有一笔订单暂未支付，确定要退出吗？
        </p>
        <div class="buttons" style="display: flex; justify-content: space-between">
          <button @click="cancel" style="
              width: 4.9rem;
              height: 1.7rem;
              border: 0.05rem solid rgba(112, 112, 112, 1);
              border-radius: 0.85rem;
              color: rgba(158, 158, 158, 1);
              margin: 0 1rem 0 0.55rem;
            ">
            取消
          </button>
          <button @click="$router.back()" style="
              width: 4.9rem;
              height: 1.7rem;
              border: 0.05rem solid rgba(112, 112, 112, 1);
              border-radius: 0.85rem;
              background-color: rgba(0, 0, 0, 1);
              color: #ffffff;
              margin: 0 1rem 0 0.55rem;
            ">
            确认
          </button>
        </div>
      </div>
    </div>
    <div class="main">
      <header>
        <van-nav-bar title="订单支付" left-arrow @click-left="onClickLeft2" />
      </header>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div class="main_content">
          <!-- 倒计时 -->
          <div class="pay-countdown" v-if="showCountDown">
            支付剩余时间&nbsp;&nbsp;
            <!-- 倒计时 注意ios系统的倒计时 支持2020/01/01  不支持2020-01-01-->
            <van-count-down :time="countdown(create_time.replace(/-/g, '/'))" format="mm:ss" @finish="finish">
            </van-count-down>
          </div>

          <div class="money">
            <span class="yen">&yen;</span>
            <span>{{ price }}</span>
          </div>
          <!-- 支付选择 -->
          <van-radio-group v-model="radio" id="pay-choose">
            <van-cell-group>
              <van-cell clickable v-for="(item, i) in payTypeList" :key="i" @click="choosepaytype(item.type)">
                <template #title>
                  <img class="icon" :src="item.icon" alt="">
                  <span class="title" style="color: #000">{{
                  item.alias_title
                }}</span>
                </template>
                <template #right-icon>
                  <van-radio :name="item.type" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>

          <van-button :disabled="disabled" round block type="info" native-type="submit" style="
          width: 16.05rem;
          height: 2.5rem;
          margin: 1.8rem auto;
          background-color: rgba(0, 0, 0, 1);
          font-size: .8rem;
        " @click="onSubmit">前往支付</van-button>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>
<script>
  import api from '../Api'
  export default {
    mixins: [api],
    data() {
      return {
        payTypeList: [],
        radio: "",
        isDialogVisible: false,
        price: 0,
        showCountDown: false,
        create_time: '',
        //倒计时  30分钟 
        interval_time: 900000,
        disabled: false,
        timer: null
      };
    },
    computed: {
      order_num() {
        return this.$route.query.order_num;
      },
      now() {
        return new Date(new Date().valueOf() - this.$store.state.differTime)
      }
    },
    mounted() {
      this.getOrderInfo()
      this.getPayType();
      this.checkorderpay();
      this.lunxun()
    },
    methods: {
      //获取订单信息
      getOrderInfo() {
        this.$Ajax('market-order/order-info', {
          orderNum: this.order_num
        }).then(rs => {
          if (rs.code == 200) {
            this.price = rs.data.price
            this.create_time = rs.data.create_time
            this.showCountDown = true
          }
        })
      },
      //获取支付方式
      getPayType() {
        this.$Ajax("market-order/get-pay-type", {
          orderNum: this.order_num,
        }).then(rs => {
          if (rs.code == 200) {
            this.payTypeList = rs.data;
          }
        });
      },
      //倒计时  剩余时间
      countdown(createtime) {
        let endtime = new Date(createtime).getTime() + this.interval_time;
        let now = new Date(this.now).getTime();
        let left = endtime - now;
        return left;
      },
      //倒计时 结束
      finish() {
        this.$toast('支付时间超时，订单自动取消')
        clearInterval(this.timer);
        this.disabled = true
      },
      //选择支付方式
      choosepaytype(type) {
        this.radio = type
      },
      cancel() {
        this.isDialogVisible = false;
      },
      confirm() {
        // 在这里执行确认操作
        this.isDialogVisible = false;
        this.$router.back();
      },
      onSubmit() {
        this.$Ajax('market-order/pay', {
          orderNum: this.order_num,
          payType: this.radio
        }).then(rs => {
          if (rs.code == 200) {
            if (rs.data.type == 'redirect') {
              window.location.href = this.$BaseURL.substring(0, this.$BaseURL.length - 1) + rs.data.url
            }
          }
        })
      },
      //轮询
      lunxun() {
        this.timer = window.setInterval(() => {
          setTimeout(() => {
            this.checkorderpay();
          }, 0);
        }, 4000);
      },
      //检查订单是否支付
      checkorderpay() {
        this.$Ajax("shop/check-order-pay", {
          orderNum: this.order_num
        }).then(rs => {
          if (rs.status == 1) {
            // if(rs.data.cdkFlag) {}
            // if(rs.data.yunFlag) {}
            this.$router.push({
              name: 'pay.success',
              query: {
                order_num: this.order_num,
                iscdk: rs.data.cdkFlag,
                yunFlag: rs.data.yunFlag
              }
            })
          }
        });
      },
    },
    destroyed() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
    watch: {
      payTypeList: {
        immediate: true,
        handler(list) {
          if (list.length == 1) {
            this.radio = list[0].type;
          }
        },
      },
    },
  };
</script>
<style lang="less" scoped>
  .dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
    }

    .content {
      text-align: center;
      background-color: #fff;
      padding: 1.1rem 1.4rem 0;
      border-radius: 0.7rem;
      z-index: 1000;
      margin: 0rem 2rem 0rem;
      width: 14.7rem;
      height: 13.4rem;

      .icon {
        width: 2.7rem;
        height: 2.85rem;
        margin-bottom: .4rem;
      }
    }

    button {
      &:active {
        opacity: 0.9;
      }
    }
  }

  :deep(.van-radio__label) {
    width: 100%;
  }

  :deep(.van-hairline--top-bottom::after) {
    border: none;
  }

  .van-radio {
    flex-direction: row-reverse;
  }

  .van-cell--clickable {
    color: #000000;
    display: flex;
    height: 3.3rem;
    justify-content: space-around;
    align-items: center;
  }

  :deep(.van-icon-success) {
    background-color: rgba(228, 228, 228, 1);
    width: 0.65rem;
    height: 0.65rem;
  }

  :deep(.van-radio__icon--checked .van-icon) {
    color: rgba(103, 0, 0, 1);
    font-size: 0.292rem;
    border-color: rgba(228, 228, 228, 1) !important;
    justify-content: center;
    align-items: center;
    display: flex;
    background-color: #ECD7D5 !important;
  }

  .main_content {
    margin-top: 2.5rem;
    padding: 2rem 1.35rem;
  }

  /deep/#pay-choose {
    border-radius: 14px;
    overflow: hidden;

    .van-cell__title {
      display: flex;
      align-items: center;
      font-size: .8rem;
      color: #000000;

      .icon {
        width: 1.2rem;
        height: 1.2rem;
        margin-right: .7rem;
      }
    }
  }

  .money {
    margin: 1.6rem auto 2.05rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2.5rem;
    color: #670000;
    font-weight: 700;

    .yen {
      font-size: 1.25rem;
      margin-right: .65rem;
    }
  }

  .pay-countdown {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: .8rem;
    color: #9e9e9e;

    .van-count-down {
      font-size: .8rem;
      color: #9e9e9e;
    }
  }
</style>